module.exports = __webpack_public_path__ + "static/section5-e2da2b9b70f00da99833f40f364fa043.jpg";